import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import { useFeature } from '@/hooks';
import { useAppSelector } from '@/redux';

const LoginDesktop = dynamic(() => import('@/components/common/Login/LoginDesktop'), { ssr: false });
LoginDesktop.displayName = 'LoginDesktop';
const LoginMobile = dynamic(() => import('@/components/common/Login/LoginMobile'), { ssr: false });
LoginMobile.displayName = 'LoginMobile';

import styles from './Login.module.scss';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { FEATURES } from '@/constants/features';

type LoginProps = {
  t: (k: string) => string;
  isSignUp?: boolean;
}

export const Login = ({ t, isSignUp }: LoginProps): React.JSX.Element => {
  const storeConf = useAppSelector(({ root }) => root.storeConf);
  const appleSignInFeatureEnabled = useFeature(storeConf, FEATURES.APPLE_SIGN_IN);
  const googleLoginFeatureEnabled = useFeature(storeConf, FEATURES.GOOGLE_LOGIN);
  const isDesktop = useScreenSizeContext().isDesktop;

  const withSocialLogin = useMemo(() => {
    return appleSignInFeatureEnabled || googleLoginFeatureEnabled;
  }, [appleSignInFeatureEnabled, googleLoginFeatureEnabled]);

  return (
    <div className={styles.container} data-test-id="login-content" data-rbf="login-content">
      {isDesktop ? (
        <LoginDesktop withSocialLogin={withSocialLogin} />
      ) : (
        <LoginMobile t={t} isSignUp={isSignUp} withSocialLogin={withSocialLogin} />
      )}
    </div>
  );
};

export default Login;
